import { Head, usePage } from '@inertiajs/react';

interface HTMLHeadProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  siteName?: string;
}

export default function HTMLHead({
  title,
  description,
  image,
  url,
  siteName = 'SheSpeaksCyber',
}: HTMLHeadProps) {
  const page = usePage();
  const serverTitle = (page.props as any).title as string | undefined;
  const serverDescription = (page.props as any).description as string | undefined;
  const serverOgImage = (page.props as any).ogImage as string | undefined;

  const effectiveTitle = title ?? serverTitle;
  const fullTitle = effectiveTitle ? `${effectiveTitle} — ${siteName}` : siteName;

  const defaultDescription = 'Find and book leading female cybersecurity speakers.';
  const effectiveDescription = description ?? serverDescription ?? defaultDescription;

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const effectiveUrl = url ?? (typeof window !== 'undefined' ? window.location.href : '');
  const effectiveImage = image ?? serverOgImage ?? `${origin}/default-og.png`;

  return (
    <Head>
      <title>{fullTitle}</title>
      <meta property="og:title" content={fullTitle} />
      <meta name="twitter:title" content={fullTitle} />

      <meta name="description" content={effectiveDescription} />
      <meta property="og:description" content={effectiveDescription} />

      <meta property="og:url" content={effectiveUrl} />
      <meta property="og:image" content={effectiveImage} />
      <meta name="twitter:image" content={effectiveImage} />
    </Head>
  );
}
